import { BaseEntity } from "yt-ng-framework";

export class UserNapomena extends BaseEntity{
    constructor(){
        super();
    }

    UserID: number;
    Napomena : string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.UserID = input.UserID;
        this.Napomena = input.Napomena;
        return this;
    }

    Serialize(input: UserNapomena) {
        return input;
    }
}